import { render, staticRenderFns } from "./AddReferenceDataDialog.vue?vue&type=template&id=31bae1dc&scoped=true"
import script from "./AddReferenceDataDialog.vue?vue&type=script&lang=ts"
export * from "./AddReferenceDataDialog.vue?vue&type=script&lang=ts"
import style0 from "./AddReferenceDataDialog.vue?vue&type=style&index=0&id=31bae1dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bae1dc",
  null
  
)

export default component.exports